import { useCallback } from "react";
import useApi from "../../helpers/api";

export default function useActions() {
  const api = useApi();

  const validateCell = (field, value) => {
    if (!value) return `${field} No puede estar vacío.`;
    const validators = {
      nombre: /^.{1,45}$/,
    };

    if (field === "nombre" && !validators.nombre.test(value)) return "Nombre debe tener entre 1 y 45 caracteres.";
    return "";
  };

  const onCellEditingStopped = useCallback(async (event, gridRef) => {
    try {
      if (!gridRef.current) return;

      const rowData = event.data;
      const columns = ["nombre"];
      const colField = event.colDef.field;
      const errorMessage = validateCell(colField, event.newValue);
      const isNewRow = String(rowData.id).length >= 8;

      if (errorMessage) {
        rowData[`tooltipError${colField}`] = errorMessage;
        await gridRef.current.api.refreshCells({ rowNodes: [event.node], columns: [colField], force: true });

        rowData[colField] = event.oldValue;
        setTimeout(() => {
          gridRef.current.api.startEditingCell({
            rowIndex: event.node.rowIndex,
            colKey: colField,
          });
        }, 10);
        return;
      }

      rowData[`tooltipError${colField}`] = "";
      rowData[`isValid${colField}`] = true;
      gridRef.current.api.refreshCells({ force: true });

      setTimeout(() => {
        rowData[`isValid${colField}`] = false;
        gridRef.current.api.refreshCells({ force: true });
      }, 1000);

      if (isNewRow) {
        if (!rowData[colField]) {
          alert(`Field ${colField} cannot be empty.`);
          gridRef.current.api.applyTransaction({ remove: [rowData] });
          return;
        }

        const nextColIndex = columns.indexOf(colField) + 1;
        if (nextColIndex < columns.length) {
          setTimeout(() => {
            gridRef.current.api.startEditingCell({
              rowIndex: event.node.rowIndex,
              colKey: columns[nextColIndex],
            });
          }, 10);
        } else {
          if (rowData.nombre && !rowData.tooltipErrornombre) {
            delete rowData.id;
            const newEmpresa = await api.createEmpresa(rowData);
            event.node.setData({ ...rowData, id: newEmpresa.id, createdAt: newEmpresa.createdAt });
          }
        }
      } else {
        if (event.newValue !== event.oldValue) {
          await api.updateEmpresa(rowData);
        }
      }
    } catch (error) {
      console.error("Error in onCellEditingStopped:", error);
    }
  }, [api]);

  const createHook = async (gridRef) => {
    if (!gridRef.current) return;

    const newRow = { id: Date.now(), nombre: "" };
    gridRef.current.api.applyTransaction({ add: [newRow] });

    setTimeout(() => {
      const rowNode = gridRef.current.api.getRowNode(newRow.id.toString());
      rowNode?.setSelected(true);
      gridRef.current.api.startEditingCell({
        rowIndex: gridRef.current.api.getDisplayedRowCount() - 1,
        colKey: "nombre",
      });
    }, 10);
  };

  const handleDelete = (rowData, setSelectedRow,setModalOpen) => {
    setSelectedRow(rowData);
    setModalOpen(true);
  }

  const confirmDelete = async (gridRef, selectedRow, setModalOpen, setSelectedRow) => {
    if (!gridRef.current || !selectedRow) return;

    try {
      const response = await api.deleteEmpresa(selectedRow.data.id);
      if (response.status === 200) {
        gridRef.current.api.applyTransaction({ remove: [selectedRow.data] });
      }
    } catch (error) {
      console.error("Error deleting row:", error);
    } finally {
      setModalOpen(false);
      setSelectedRow(null);
    }
  };

  return { handleDelete, createHook, onCellEditingStopped, validateCell, confirmDelete };
}
